<template>
    <div :class="[rootCssClass]" class="dropdown">
        <div :class="{ 'has-value': hasValue }" class="selected" @click="toggleOpen">

            <slot name="icon">
                <span class="icon toggle"></span>
            </slot>
        </div>

        <div v-show="opened" class="option-dialog">
            <div class="container">
                <div v-show="selected != null" class="message">
                    <button class="no-border primary"
                            type="button"
                            @click.stop="resetValue"
                    >Очистить выбранное
                    </button>
                </div>

                <Node v-for="it in originalRoot"
                      :key="it.key" :flat-groups="flatGroups"
                      :selectable-groups="selectableGroups"
                      :selected="selected"
                      :value="it"
                      @selected="select($event)">
                    <template #default="{item, title, disabled}">
                        <slot :disabled="disabled"
                              :item="item"
                              :title="title"
                              name="option"
                        >{{ title }}
                        </slot>
                    </template>
                </Node>
            </div>
        </div>
    </div>
</template>

<script>
import { SelectBase, ScalarValueMixin, NoSearchMixin } from '@dsee/components/selects/select.base.js';
import Node from '@/common/comp/selects/node.scalar.vue';


export default {
    name: 'DropdownIconed',
    mixins: [ SelectBase, ScalarValueMixin, NoSearchMixin ],
    components: { Node },
};
</script>

<style lang="scss" scoped>
@import '~@dsee/mixins.scss';

.dropdown {
    position: relative;
    font-size: var(--text-font-size);
    line-height: var(--text-line-height);
    color: var(--text-color);
    cursor: pointer;
    transition: var(--transition-function);

    &:hover:not(.opened):not(.disabled) .selected {
        .icon {
            opacity: 1;
        }
    }

    .selected.has-value {
        color: var(--theme-accent-color);
        opacity: 1;
    }

    .selected:not(.has-value) > .icon {
        opacity: 0.5;
        transition: var(--transition-function);
    }

    .selected > .icon.toggle {
        @include icon(16px, 16px);
        background-image: url('~@dsee/components/selects/icons/chevron.svg');
    }

    &.disabled .selected > .icon {
        opacity: 0.25;
    }

    .option-dialog {
        position: absolute;
        z-index: 1;
        top: 100%;
        min-width: 200px;
        box-sizing: border-box;
        margin-top: var(--option-dialog-margin-top);
        background: var(--option-dialog-background);
        box-shadow: var(--option-dialog-shadow);
        border: var(--option-dialog-border);
        border-radius: var(--option-dialog-border-radius);
        width: 100%;
    }

    .option-dialog .container {
        @include scrollbar;
        max-height: var(--option-dialog-max-height);
        border-radius: var(--option-dialog-border-radius);
        padding: var(--option-dialog-padding);
        overflow: auto;
    }

    .option-dialog .append,
    .option-dialog .message {
        display: block;
        padding: var(--input-padding);
    }

    .option-dialog .append.first {
        border-bottom: var(--input-border);
    }

    .option-dialog .message {
        color: var(--input-disabled-color);
    }

    .selected {
        padding: 0;
        border: none;
        border-radius: 0;
        align-items: center;
        display: flex;
    }
}
</style>
